/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { nodeProvidersGetApiV3NodeProvidersNodeProviderIdNodes } from "../../funcs/nodeProvidersGetApiV3NodeProvidersNodeProviderIdNodes.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations.GetApiV3NodeProvidersNodeProviderIdNodesRequest$inboundSchema,
};

export const tool$nodeProvidersGetApiV3NodeProvidersNodeProviderIdNodes:
  ToolDefinition<typeof args> = {
    name: "node-providers-get-api-v3-node-providers-node-provider-id-nodes",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await nodeProvidersGetApiV3NodeProvidersNodeProviderIdNodes(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
